import Vue from 'vue';
import 'typeface-roboto';
import axios from 'axios';
import { rutInputDirective, rutFilter } from 'vue-dni';
import VueSimpleAlert from 'vue-simple-alert';

import App from './App.vue';

import './assets/app.scss';

import './plugins/moment';
import './plugins/fontAwesome';
import './plugins/filters';

Vue.use(axios);
Vue.use(VueSimpleAlert);
Vue.directive('rut', rutInputDirective);
Vue.filter('rutFilter', rutFilter);
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
